import { heliosSizes } from '~/constants/common/resizeBreakpoints';
import { useGetFavorites } from '~/hooks/common/favorites';
import useGeolocation from '~/hooks/common/geolocation/useGeolocation';
import useSyncGeolocation from '~/hooks/common/sync/useSyncGeolocation';
import useSynchronizeAuth from '~/hooks/common/sync/useSynchronizeAuth';
import useDataDogRUM from '~/hooks/common/telemetry/useDataDogRUM';
import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';
import useResizeListener from '~/hooks/common/ui/useResizeListener';
import useSendViewedEvent from '~/hooks/ev/useSendViewedEvent';

export default function EvData() {
  useDataDogRUM();
  useSynchronizeAuth();
  useSendViewedEvent();
  useResizeListener(heliosSizes);
  useGetFavorites();
  useTrackClickEvents();
  useGeolocation();
  useSyncGeolocation();

  return null;
}
